export const DEFAULT_FLAG = '/icons/logo/emblem.svg';
